import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Snackbar, Alert, Button, Paper, Typography, Box } from '@mui/material';

const ApprovalPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [approved, setApproved] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' as 'success' | 'error' });
    const token = searchParams.get('token');

    const approveInvite = async () => {
        if (!token) {
            setSnackbar({ open: true, message: 'Invalid approval link', severity: 'error' });
            return;
        }

        setLoading(true);
        try {
            const response = await fetch('https://qaqj2uc5pc.execute-api.us-east-2.amazonaws.com/prod/api/registration-invite/approve', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token })
            });

            const result = await response.json();
            
            if (response.ok) {
                setSnackbar({ open: true, message: 'Invitation approved! User has been notified.', severity: 'success' });
                setApproved(true);
            } else {
                setSnackbar({ open: true, message: result.error || 'Failed to approve invite', severity: 'error' });
            }
        } catch (error) {
            setSnackbar({ open: true, message: 'Network error', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Paper sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="h4" component="h1" color="error" gutterBottom>
                        Invalid Link
                    </Typography>
                    <Typography>This approval link is invalid or expired.</Typography>
                </Paper>
            </Box>
        );
    }

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Paper sx={{ p: 4, width: '100%', maxWidth: 400, textAlign: 'center' }}>
                {approved ? (
                    <>
                        <Typography variant="h4" component="h1" color="success.main" gutterBottom>
                            Approved!
                        </Typography>
                        <Typography>The invitation has been approved and the user has been notified.</Typography>
                    </>
                ) : (
                    <>
                        <Typography variant="h4" component="h1" gutterBottom>
                            Approve Invitation
                        </Typography>
                        <Typography color="text.secondary" sx={{ mb: 3 }}>
                            Click the button below to approve this registration invitation.
                        </Typography>
                        <Button
                            onClick={approveInvite}
                            disabled={loading}
                            variant="contained"
                            color="success"
                            fullWidth
                        >
                            {loading ? 'Approving...' : 'Approve Invitation'}
                        </Button>
                    </>
                )}
            </Paper>
            
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default ApprovalPage;